import { NgModule } from '@angular/core';
import {AppCommonModule} from "@app/shared";
import {CommonModule} from "@angular/common";
import {HandsontableModule} from "@app/handsontable/handsontable.module";
import { CreditCardFormModule } from "@app/shared";
import {DynamicCertificateFormParserModule} from "@app/shared/dynamic-certificate-form-parser/dynamic-certificate-form-parser.module";
import {ModalModule} from "ngx-bootstrap";
import {
    AssetDefectListModalComponent
} from "@app/shared/new-assets-list/asset-defect-list-modal.component";
import {CsAgGridJsModule} from "@app/shared/cs-ag-grid-js/cs-ag-grid-js.module";

@NgModule({
    declarations: [AssetDefectListModalComponent ],
    exports: [
        AssetDefectListModalComponent
    ],
    imports: [
        CommonModule,
        DynamicCertificateFormParserModule,
        ModalModule,
        CsAgGridJsModule
    ]
})
export class AssetDefectListModal { }
